export default __webpack_public_path__ + "static/media/server-secure-illustration.7c9a441e.svg";